var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('knowledge-library',{attrs:{"show-search-results-heading":_vm.showSearchResultsHeading,"location-link":_vm.locationLink}})}
var staticRenderFns = []
export { render, staticRenderFns }